// extracted by mini-css-extract-plugin
export default {"hover":"Sidebar_hover__pvWXO","sidebar-overlay":"Sidebar_sidebar-overlay__SKICV","sidebar-footer":"Sidebar_sidebar-footer__O4qJS","signout":"Sidebar_signout__H-gDH"};